/* -------------------------------------------------------------------------
 * Sayuri signature · incense-smoke  (Inari Ōkami)
 * -------------------------------------------------------------------------
 * Port of `IncenseSmoke` in the design file (line ~1060). Slow, darker,
 * more dramatic tendrils — bigger than tea-steam, with rotation and
 * multiply blend so the smoke looks like it's resting on the page rather
 * than glowing through it.
 *
 * Scent character: "Cedar wood at the shrine gate, kitsune at twilight,
 * smoke in the trees." Sacred + heavy + atmospheric.
 * ----------------------------------------------------------------------- */
(function () {
  'use strict';
  var SA = window.SayuriAnimations;
  if (!SA) { return; }

  SA.register('incense-smoke', {
    mount: function (el, ctx) {
      var n = ctx.intensity === 'lush' ? 10 : 6;
      var accent = ctx.accent;
      var rand = ctx.seed('incense-smoke'.charCodeAt(0) * 131 + 13 * 7919);

      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var left = rand() * 100;
        var w = 250 + rand() * 300;       // 250–550px wide
        var dur = 22 + rand() * 18;       // 22–40s
        var delay = -rand() * 22;
        var variant = i % 3;

        var p = document.createElement('div');
        p.className = 'sayuri-incense-smoke';
        p.style.position = 'absolute';
        p.style.left = left + 'vw';
        p.style.bottom = '-150px';
        p.style.width = w + 'px';
        p.style.height = (w * 2) + 'px';
        p.style.background =
          'radial-gradient(ellipse 40% 60% at 50% 80%, ' +
          accent + '44, ' + accent + '00 70%)';
        p.style.filter = 'blur(30px)';
        p.style.mixBlendMode = 'multiply';
        p.style.animation = 'smoke-rise-' + variant + ' ' + dur + 's ease-out ' + delay + 's infinite';

        frag.appendChild(p);
      }
      el.appendChild(frag);
    },
    css: [
      '@keyframes smoke-rise-0 { 0%{opacity:0;transform:translate(0,0) scale(0.7) rotate(-3deg);} 20%{opacity:0.8;} 100%{opacity:0;transform:translate(80px,-130vh) scale(2.4) rotate(8deg);} }',
      '@keyframes smoke-rise-1 { 0%{opacity:0;transform:translate(0,0) scale(0.7) rotate(2deg);} 20%{opacity:0.7;} 100%{opacity:0;transform:translate(-100px,-130vh) scale(2.6) rotate(-6deg);} }',
      '@keyframes smoke-rise-2 { 0%{opacity:0;transform:translate(0,0) scale(0.7);} 20%{opacity:0.75;} 100%{opacity:0;transform:translate(40px,-130vh) scale(2.3);} }'
    ].join('')
  });
})();
